import { SignInButton, UserButton } from "@clerk/clerk-react"
import Button from "@mui/material/Button"
import { Authenticated, Unauthenticated } from "convex/react"

export function Session() {
  return (
    <>
      <Unauthenticated>
        <SignInButton>
          <Button variant="outlined">Sign In</Button>
        </SignInButton>
      </Unauthenticated>
      <Authenticated>
        <UserButton />
      </Authenticated>
    </>
  )
}
